import axios from 'axios';

const api = axios.create({
  baseURL: 'https://hemovigiliancia--api.herokuapp.com/api',
});

export default api;